// Valid languages to server-side render in production
export var LANGUAGES = ['en'];

// Server side rendered languages
export var LANGUAGES_SSR = ['en'];

// Work in progress
export var LANGUAGES_IN_PROGRESS = LANGUAGES.slice();
export var LANGUAGES_IGNORE_PAGES = function LANGUAGES_IGNORE_PAGES(pathname) {
  // We don't have the bandwidth like Qt to translate our blog posts
  // https://www.qt.io/zh-cn/blog
  if (pathname === '/blog' || pathname.startsWith('/blog/')) {
    return true;
  }
  if (pathname === '/size-snapshot/') {
    return true;
  }
  return false;
};